export const BRAND = {
  name: "Vachhraj Estate",
  tagline: "Ahmedabad West's Trusted Real Estate Consultant",
};

export const CONTACT = {
  phoneDisplay: "+91 95121 23570",
  phoneTel: "+919512123570",
  whatsappNumber: "919512123570",
  whatsappLink: "https://wa.me/919512123570?text=Hello%20Vachhraj%20Estate%2C%20I%27d%20like%20to%20enquire%20about%20a%20property.",
  email: "info@vachhrajestate.com",
  addressLine1: "GF 121, Alpha Bazaar",
  addressLine2: "8th Floor 809, Venus Atlantis Corporate Park",
  addressLine3: "100 Feet Road, near Shell Petrol Pump",
  addressLine4: "Satellite, Prahlad Nagar",
  addressLine5: "Ahmedabad, Gujarat 380015",
  hours: [
    { day: "Monday – Saturday", time: "9:30 AM – 8:30 PM" },
    { day: "Sunday", time: "By appointment only" },
  ],
  mapsEmbed: "https://www.google.com/maps?q=Venus+Atlantis+Corporate+Park,+100+Feet+Road,+Prahlad+Nagar,+Ahmedabad&output=embed",
  mapsDirections: "https://www.google.com/maps/dir/?api=1&destination=Venus+Atlantis+Corporate+Park+Prahlad+Nagar+Ahmedabad",
};

export const SERVICES = [
  {
    slug: "commercial",
    title: "Commercial",
    short: "Offices, showrooms & retail spaces",
    body: "High-footfall retail, grade-A offices and ready showrooms across Ahmedabad West's most sought-after corporate corridors — SG Highway, Sindhu Bhavan Road, Iscon Cross Roads and Prahlad Nagar. We assist with leasing, outright purchase, fit-out handovers and long-term investment plays.",
    points: [
      "Ready-to-move offices & pre-leased assets",
      "Retail spaces on main roads with high visibility",
      "Showrooms with ample frontage and parking",
      "Warm-shell & fully fitted options",
    ],
  },
  {
    slug: "residential",
    title: "Residential",
    short: "Apartments, bungalows & villas",
    body: "From compact 2BHKs for young families to sky-villas and private bungalows in Bodakdev, Thaltej, Ambli and South Bopal — every recommendation is tied to your lifestyle, school zone, commute and long-term appreciation.",
    points: [
      "2BHK, 3BHK & 4BHK premium apartments",
      "Independent bungalows & private villas",
      "Ready possession and under-construction options",
      "Rental & outright across all budget bands",
    ],
  },
  {
    slug: "industrial",
    title: "Industrial",
    short: "Warehouses, sheds & industrial plots",
    body: "Industrial land parcels, ready sheds and logistics-ready warehouses in and around Ahmedabad's expanding industrial belt. We work closely with manufacturers, logistics operators and investors on both purchase and long-lease arrangements.",
    points: [
      "Industrial sheds (RCC & PEB)",
      "Godowns & logistics warehouses",
      "N.A. industrial plots with clear titles",
      "Leaseback and sale-and-lease-back deals",
    ],
  },
  {
    slug: "weekend-villa",
    title: "Weekend Villa",
    short: "Farmhouses & weekend retreats",
    body: "Curated weekend homes and farmhouses on the outskirts of Ahmedabad — gated farm communities, private agricultural retreats and pool villas along Shela, Shilaj and Sanand belts. Hand-picked for peace, privacy and solid title.",
    points: [
      "Gated farmhouse communities",
      "Private pool villas & retreats",
      "Agricultural land with farm house rights",
      "Turn-key & customisable plots",
    ],
  },
  {
    slug: "plotting",
    title: "Plotting",
    short: "Residential & N.A. plots",
    body: "Clean-title plotting schemes across Shela, South Bopal, Science City extension and Sanand — ranging from 150 sq yd residential plots to large land parcels for developers. Every plot vetted for approvals, 7/12, and future infrastructure growth.",
    points: [
      "N.A. & residential plotting schemes",
      "Corner, road-touch & premium plots",
      "Developer land parcels",
      "Clear title, 7/12 & layout approvals",
    ],
  },
];

export const AREAS = [
  {
    name: "Prahlad Nagar",
    tag: "Corporate Hub",
    body: "Central business district with grade-A offices, premium 3–4BHK apartments and top-tier F&B. Walk-to-work culture, 100 ft & Corporate Road connectivity.",
  },
  {
    name: "Satellite",
    tag: "Established Core",
    body: "One of Ahmedabad's most evolved residential zones — schools, hospitals and retail at every corner, with a steady rental market and deep resale liquidity.",
  },
  {
    name: "Bodakdev",
    tag: "Premium Residential",
    body: "High-end apartments and bungalow plots near SG Highway. Preferred by senior professionals and business families for its serenity and status value.",
  },
  {
    name: "Sindhu Bhavan",
    tag: "Luxury Corridor",
    body: "Ahmedabad's fastest-moving luxury belt — flagship showrooms, fine-dining and 4BHK sky-residences. Strong commercial returns and brand-retail footprint.",
  },
  {
    name: "Vastrapur",
    tag: "Lifestyle District",
    body: "Vastrapur Lake, IIM-A proximity, schools and mid-to-premium housing. A balanced pick for end-users who want everything within a 2 km radius.",
  },
  {
    name: "VIP Road",
    tag: "Evolving Main Artery",
    body: "Rapidly appreciating stretch along Bopal–Shela with mid-premium housing and new retail formats. Ideal mix of affordability and growth.",
  },
  {
    name: "Shela",
    tag: "Next-Gen Suburb",
    body: "One of the fastest-growing micro-markets — modern towers, gated communities, international schools and serious long-term appreciation potential.",
  },
  {
    name: "South Bopal",
    tag: "Family Suburb",
    body: "Low-rise gated communities, plotting schemes and bungalow rows. A preferred choice for families wanting space, green cover and school access.",
  },
  {
    name: "Thaltej",
    tag: "Connectivity King",
    body: "SG Highway frontage, metro access and a blend of premium apartments and commercial frontage. Strong rental yields for investors.",
  },
  {
    name: "Iscon Ambli",
    tag: "Luxury Residential",
    body: "Ambli–Bopal Road's bungalow and sky-villa belt. Large configurations, low density and premium brand of builders.",
  },
  {
    name: "Science City",
    tag: "Upcoming Growth",
    body: "A master-planned extension with wide roads, institutional anchors and smart plotting schemes — excellent ground floor for long-hold investors.",
  },
  {
    name: "SG Highway",
    tag: "Commercial Spine",
    body: "Ahmedabad's primary commercial spine — flagship offices, showrooms and hotels. Prime pre-leased and outright commercial inventory.",
  },
];

export const INTERESTS = [
  "Commercial",
  "Residential",
  "Industrial",
  "Weekend Villa",
  "Plotting",
  "Other",
];

export const BUDGET_RANGES = [
  { value: "", label: "Any budget" },
  { value: "upto-25L", label: "Upto ₹25 Lakh" },
  { value: "25L-50L", label: "₹25 Lakh - ₹50 Lakh" },
  { value: "50L-75L", label: "₹50 Lakh - ₹75 Lakh" },
  { value: "75L-1Cr", label: "₹75 Lakh - ₹1 Crore" },
  { value: "1Cr-1.5Cr", label: "₹1 Crore - ₹1.5 Crore" },
  { value: "1.5Cr-2Cr", label: "₹1.5 Crore - ₹2 Crore" },
  { value: "2Cr-3Cr", label: "₹2 Crore - ₹3 Crore" },
  { value: "3Cr-5Cr", label: "₹3 Crore - ₹5 Crore" },
  { value: "5Cr-plus", label: "₹5 Crore+" },
];